import React from "react";

function LivDay2026() {
  return (
    <div style={{ 
      width: "100vw", 
      height: "100vh",
      margin: 0,
      padding: 0,
      overflow: "hidden"
    }}>
      <iframe
        src={`${process.env.PUBLIC_URL}/livday2026/index.html`}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: "block"
        }}
        title="Liv Day 2026 Game"
        allow="fullscreen"
        allowFullScreen
      />
    </div>
  );
}

export default LivDay2026;

